<script lang="ts">
    import md5 from 'md5';
    import type {Member} from "../firestore";
    import {Avatar} from "svelte-materialify";

    export let value: Member;
</script>

<div class="member">
    <Avatar size={32} style="flex-shrink:0">
        <img src="https://www.gravatar.com/avatar/{md5(value.email)}?d=retro" alt="Avatar for {value.name}" />
    </Avatar>
    <div class="pa-2">
        {value.name}
    </div>
</div>

<style>
    .member {
        display: flex;
        align-items: center;
    }
</style>
